import { useMemo, useState } from 'react';
import { Plan } from '@wix/ambassador-pricing-plans-v3-plan/types';
import { uouActionAtCheckout } from '@wix/bi-logger-pricing-plans-data/v2';
import { useBi } from '@wix/yoshi-flow-editor';
import { termsAndConditionsCheckboxAction } from '../utils/bi';

export const useTermsAndConditions = (plan: Plan) => {
  const bi = useBi();
  const acceptRequired = plan.termsAndConditionsSettings?.acceptRequired ?? false;
  const isAcceptedByDefault = plan.termsAndConditionsSettings?.acceptedByDefault ?? false;
  const [isTickedOff, setIsTickedOff] = useState(isAcceptedByDefault);
  const [shouldDisplayError, setShouldDisplayError] = useState(false);
  const showCheckbox = acceptRequired && Boolean(plan.termsAndConditions);
  const isValid = showCheckbox ? isTickedOff : true;

  return useMemo(
    () => ({
      showCheckbox,
      checkbox: {
        isTickedOff,
        setIsTickedOff: (newValue: boolean) => {
          setIsTickedOff(newValue);
          bi.report(
            uouActionAtCheckout({ action: termsAndConditionsCheckboxAction(newValue), planGuid: plan.id ?? undefined }),
          );
        },
        shouldDisplayError,
        setShouldDisplayError,
        isValid,
      },
      value: plan.termsAndConditions ?? '',
    }),
    [bi, isTickedOff, isValid, plan.id, plan.termsAndConditions, shouldDisplayError, showCheckbox],
  );
};
